import { render } from "./SpeakerProfile.vue?vue&type=template&id=feb84d70&scoped=true"
import script from "./SpeakerProfile.vue?vue&type=script&lang=js"
export * from "./SpeakerProfile.vue?vue&type=script&lang=js"

import "./SpeakerProfile.vue?vue&type=style&index=0&id=feb84d70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb84d70"]])

export default __exports__